import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.01 5.478a1 1 0 0 0-1.757-.956l-2.44 4.48-2.895.93A2.76 2.76 0 0 0 1 12.56v1.701a2.76 2.76 0 0 0 2.761 2.762h.275c.037.254.1.538.204.828a3.2 3.2 0 0 0 1.062 1.48c.569.43 1.303.668 2.198.668.896 0 1.63-.237 2.201-.664.563-.42.892-.968 1.083-1.468.112-.296.181-.586.223-.844h2.992c.029.249.083.524.177.806a3.06 3.06 0 0 0 1.07 1.508c.58.431 1.333.662 2.254.662.92 0 1.673-.23 2.254-.663a3.06 3.06 0 0 0 1.07-1.507c.108-.322.162-.636.188-.91a2.764 2.764 0 0 0 1.923-3.317l-.632-2.571A2.76 2.76 0 0 0 19.62 8.93h-.543l.37-1.114a1 1 0 1 0-1.897-.632L16.97 8.93h-2.891l.37-1.114a1 1 0 1 0-1.897-.632L11.97 8.93h-.958l-2.847-.062z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: t };
export {
  d as default,
  t as render
};
//# sourceMappingURL=ic_convertible_filled-DfBDP5NB.js.map
